import History from '@pages/History/index';
import React from 'react';
import { RouteObject } from 'react-router-dom';
import AppLayout from '../_layout/AppLayout';

export default [
  {
    path: '/history',
    element: <AppLayout />,
    children: [{ index: true, element: <History /> }],
  },
] as RouteObject[];
